function Pill({ label }) {
  return (
    <div className="rounded-full text-gray-200 bg-gray-700 px-5 py-2 min-w-max flex items-center">
      {label}
    </div>
  );
}

export default Pill;
